export const simpleListSections = {
  newFeaturesList: "newFeaturesList",
  improvementsList: "improvementsList"
};
